import { LoadingLogo } from '@/components/atoms/LoadingLogo/LoadingLogo'
import CopyrightSection from '@/components/organisms/CopyrightSection/CopyrightSection'
import FooterSynapses from '@/components/organisms/FooterSynapses/FooterSynapses'
import PageWrapper from '@/components/organisms/PageWrapper/PageWrapper'
import React, { Suspense, lazy } from 'react'

// Carga los componentes de manera dinámica
const Header = lazy(async () => await import('@/components/organisms/Header/Header'))
const BannerHome = lazy(async () => await import('@/components/templates/BannerHome/BannerHome'))
const InnovationDigitalTransformation = lazy(async () => await import('@/components/templates/InnovationDigitalTransformation/InnovationDigitalTransformation'))
const StrategicConnections = lazy(async () => await import('@/components/templates/StrategicConnections/StrategicConnections'))
const WhyChooseSynapsesGroup = lazy(async () => await import('@/components/templates/WhyChooseSynapsesGroup/WhyChooseSynapsesGroup'))
const CarruselBusinessContainer = lazy(async () => await import('@/components/templates/CarruselBusiness/CarruselBusinessContainer'))
const BusinessDevelopment = lazy(async () => await import('@/components/templates/BusinessDevelopment/BusinessDevelopment'))
const FormContactSynapses = lazy(async () => await import('@/components/templates/FormContactSynapses/FormContactSynapses'))

export const Home: React.FC = () => {
  const buildDate = new Date().toISOString()

  return (
    <PageWrapper
      title='Synapses Group'
      description='Synapses Group offers secure and innovative solutions for payments the management of business payments, risk management and corporate trade finance. Streamline your business with our expertise.'
      url='https://www.synapses.com'
      keywords={[
        'Synapses Group',
        'BTC TRADING CORPORATION',
        'Trade finance solutions',
        'Trading Corporation',
        'International Financial transactions',
        'Secure International payments',
        'Financial risk management',
        'Specialized financing',
        'Innovative financial services',
        'Global business solutions',
        'International supplier payments',
        'Secure and innovative financial solutions for businesses in Synapses Group.',
        'Optimise your international payments with Synapses Group',
        'Mitigate financial risks and expand globally',
        'Tailor-made trade finance solutions for Synapses Group companies',
        'Secure, efficient and innovative: Synapses Group'
      ]}
      language='en'
      publishedTime={buildDate}
    >
      <Suspense fallback={<LoadingLogo />}>
        <div className='min-h-screen flex flex-col overflow-hidden relative'>
          <Header />
          <main className='flex-grow'>
            <section id='home' className='lg:pl-[300px] lg:pr-[100px]'>
              <BannerHome />
            </section>
            <section id='innovation' className='lg:pl-[300px] lg:pr-[100px] bg-[#F9F9F9]'>
              <InnovationDigitalTransformation />
            </section>
            <section id='strategic' className=''>
              <StrategicConnections />
            </section>
            <section id='whyChoose' className='lg:pl-[300px] lg:pr-[100px] mt-[100px]'>
              <WhyChooseSynapsesGroup />
            </section>
            <section id='clients' className='mt-[100px] bg-[#FAFAFA]'>
              <CarruselBusinessContainer />
            </section>
            <section id='development' className='lg:pl-[300px] lg:pr-[100px]'>
              <BusinessDevelopment />
            </section>
            <section id='formContactSynapses' className='lg:pl-[300px] lg:pr-[100px] mt-[100px] bg-[#FAFAFA]'>
              <FormContactSynapses />
            </section>
          </main>
          <div className=''>
            <FooterSynapses />
          </div>
          <div className=''>
            <CopyrightSection />
          </div>
        </div>
      </Suspense>
    </PageWrapper>
  )
}
